import settings from '../../../config/general.js'

export default function getShopConfig(configKey) {
  if ({}.hasOwnProperty.call(settings, configKey)) return settings[configKey]
  throw new Error('Invalid config key.')
}
